export * from './angularfire2';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// /Users/azerty/friendlychat-web/cloud-functions-angular-start/~/angularfire2/public_api.js
// module id = ../../../../angularfire2/public_api.js
// module chunks = 3